import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RemarksModalComponent } from './remarks-modal.component';
import { ModalModule } from '../modal/modal.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { InputSubmitModule } from '../input-submit/input-submit.module';
import { InputFieldModule } from '../input-field/input-field.module';

@NgModule({
  declarations: [RemarksModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    InputSubmitModule,
    InputFieldModule,
    ReactiveFormsModule,
    ModalModule
  ],
  exports: [RemarksModalComponent]
})
export class RemarksModalModule {}
